import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";

import { getSelectBoxOptions } from "utils/request/options";

export const useSelectBoxOptions = (params) => {
    return useQuery("selectBoxOptions", (e) => getSelectBoxOptions(params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};
